<template>
    <div grey-back full-height>

        <!-- <v-toolbar flat fixed>
            <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

            <v-toolbar-title class="white--text">Group</v-toolbar-title>
        </v-toolbar>

        <v-form class="form-element hasToolbar hasFooter grey-back">


            <v-layout wrap padding-top-bottom-ten white-background>

                <v-flex xs12 sm12 md12 form-item>
                   <v-text-field  v-model="Form.name" label="Name" placeholder=" " v-validate="'required'" :error-messages="errors.collect('name')" data-vv-name="name" required></v-text-field>
                </v-flex>

                <v-flex xs12 sm12 md12 form-item>
                   <v-checkbox class="check_box" label="Primary Group" v-model="Form.isPrimaryAccountGroup"></v-checkbox>
                </v-flex>

                <v-flex xs12 sm12 md12 form-item @click="fn_openDialogNatureList" v-if="Form.isPrimaryAccountGroup">
                    <v-text-field  
                        readonly 
                        v-model="Form.natureTitle" 
                        label="Nature" 
                        placeholder=" " 
                        append-icon="arrow_drop_down"
                        v-validate="'required'" 
                        :error-messages="errors.collect('nature')" 
                        data-vv-name="nature" 
                        required>
                    </v-text-field>
                </v-flex>


                <div v-if="!Form.isPrimaryAccountGroup" full-width>
                    <v-flex xs12 sm12 md12 form-item 
                    @click="fn_openParentGroupsDialog('android', 'AccountGroups', 'field_accountGroups')">

                       <v-text-field  
                            readonly 
                            v-model="Form.parentGroupName" 
                            label="Parent Group" 
                            placeholder=" "
                            append-icon="arrow_drop_down"
                            ref="field_accountGroups" 
                            :onUpdate="fn_updateParentGroup" 
                            v-validate="'required'" 
                            data-vv-name="parent group"
                            :error-messages="errors.collect('parent group')" 
                            required>
                        </v-text-field>
                    </v-flex>
                </div>

            </v-layout>

            <div style="position:fixed;bottom:0" full-width>
                <v-btn noroundborders color="primary" block nomargin class="height48" @click="fn_checkValidations" style="border-radius:0;">Save</v-btn>
            </div>
            
                
        </v-form> -->


        <v-snackbar v-model="snackbar" :timeout="2000">{{snackbar_msg}}</v-snackbar>

        <dialog-form ref="ref_dialogForm" :closeDialog="fn_closeDialogForm"></dialog-form>

        <dialog-discard ref="ref_dialogDiscard" :draftAction="fn_goBack" :save="fn_validate"></dialog-discard>


    </div>
</template>

<script>
// const dialogjs =  require('../dialog').dialogjs;
// const menuItem = require('../../../../config.js').configs.menuItem;

// import dialogNatureList from './dialogs/dialog_nature'
// import dialogDiscard from '../../../dialogs/dialog_discard'
import dialogDiscard from '../../../dialogs/dialog_discard'
import {draftMixin} from '../../../draft_mixin'

// import dialogDraftItems from '../../../dialogs/dialog_draft_items'

import dialogForm from './dialogs/dialog_form'

    export default{
        mixins: [draftMixin],
        data(){
            return{
                // Form:{"accountGroupId":null, "description":null, "groupTypeId":501, "isPrimaryAccountGroup":true, "name":null, "parentAccountGroupId":null, "parentGroupName":null, "title":null, "nature":null, "natureTitle":null, "isSystem":0, "status":1,
                //  "acRefDetails":false, "runningCustomerGroup":false, "disableRunningCustomer":false, "disableAcRefDetails":false, "draftItems":[], "createdDate":null, "modifiedDate":null
                //  },
                Form:{"godownId":null, "name":null, "address":null, "stateId":null, "state":null, "additionalData":{}, 'godownType':null},
                tagId:null,
                draftStorageId:null,
                dialogStorageId:null,
                backButtonPress: false,
                snackbar:false,
                snackbar_msg:null,
                unwatch:false,
                disableOnSave:false,
                selectedState:null
            }
        },
        watch:{
            'Form': {
                handler: function (){
                     if(!this.unwatch){
                        this.fn_saveDraft(this.draftStorageId, this.Form.name);
                     }
                     this.unwatch = false;
                 },
                 deep: true
            }
        },
        components:{
            'dialog-form':dialogForm,
            'dialog-discard': dialogDiscard,
        },
        methods:{

            fn_closeDialogForm: function(){
                this.askToDiscard = true;
                if(this.fn_showDialogDiscard()){
                    this.$refs['ref_dialogDiscard'].openDialogWeb();
                }
                else{
                    this.fn_goBack();
                }
            },

            fn_checkValidations: function(){
                this.fn_post();
            },

            fn_saveLocal: function(dataObj){
                var self = this;
                this.postData('PostGodown', dataObj, 
                    {
                        onSuccess: function(response){
                            console.log(response);
                            let status = JSON.parse(response);
                            if(status) {
                                self.fn_cleanUp();
                            }
                            else {
                                self.$eventHub.$emit('snackbarAlert', {msg:'Already exists with this name'});
                            }

                            self.disableOnSave = false;
                            self.saveBtnKey++;
                        },
                        onError: function(error){
                            self.disableOnSave = false;
                            self.saveBtnKey++;
                            console.log(error);
                        }
                    }
                );
            },

            fn_cleanUp: function () {

                // this.loadedFromDraft = false;

                if(this.$route.query.ls){
                    let data = {};
                    data.type = this.$route.query.type ? this.$route.query.type : 'godown';
                    data.id = this.Form.godownId;
                    data.name = this.Form.name;
                    localStorage.setItem('newItem', JSON.stringify(data));
                    // localStorage.setItem('closeDialog', 1);
                }

                this.$eventHub.$emit('UpdateGodownList', {});
                this.fn_goBack();

                // let self = this;
                // this.fn_removeDraft(this.draftStorageId, function(){

                //     if(localStorage.getItem("master_items_state")){
                //         let obj = JSON.parse(localStorage.getItem("master_items_state"));
                //         obj.itemId = self.Form.accountGroupId;
                //         localStorage.setItem("master_items_state",JSON.stringify(obj));
                //     }

                //     self.$router.go(-1);
                // });
            },

            fn_post: function(){	
                if(!this.Form.godownId){
                    this.Form.godownId = this.guid();
                    this.Form.createdDate = this.$root.fn_getLocalDateFormat();
                }

                // this.Form.modifiedDate = new Date();
                this.Form.modifiedDate = this.$root.fn_getLocalDateFormat();

                this.Form.name = this.Form.name.trim();
                this.Form.stateId = this.selectedState.itemId;
                this.Form.state = this.selectedState.itemName;
                console.log(this.Form);
                this.fn_saveLocal(this.Form);
            },

            fn_get: function(itemId){
                var self = this;
                this.getData('GetGodown', itemId, 
                    {
                        onSuccess: function(response){
                            console.log(self.Form);
                            self.unwatch = true;
                            self.Form = JSON.parse(response);
                            if(self.Form.stateId){
                                self.selectedState = {itemId:self.Form.stateId, itemName:self.Form.stateName};
                            }
                            // self.$root.fn_copyFormObject(self.Form, self.formId);
                        }, 
                        onError: function(error){
                          console.log(error);
                        }
                    }
                );
            },

            fn_clearForm: function(){
                // this.Form = {"accountGroupId":null, "description":null, "groupTypeId":501, "isPrimaryAccountGroup":true, "name":null, "parentAccountGroupId":null, "parentGroupName":null, "title":null, "nature":null, "natureTitle":null, "isSystem":0, "status":1,
                //  "acRefDetails":false, "runningCustomerGroup":false, "disableRunningCustomer":false, "disableAcRefDetails":false, "draftItems":[], "createdDate":null, "modifiedDate":null
                // };
                this.unwatch = true;
                this.Form = {"accountGroupId":null, "description":null, "groupTypeId":501, "isPrimaryAccountGroup":true, "name":null, "parentAccountGroupId":null, "parentGroupName":null, "title":null, "nature":null, "natureTitle":null, "isSystem":0, "status":1, "draftItems":[], "createdDate":null, "modifiedDate":null, "isNew":true, "selectedNature":null, "selectedParentGroup":null
                };
                setTimeout(() => {
                    this.Form.isNew ? this.$root.fn_copyFormObject(this.Form, this.formId) : '';
                }, 100);
                // this.$validator.reset();
            },

            fn_menuItemClick: function(tagId, menuId, menuAction){
                // tagId id form future use
                // menuId id form future use

                this.backButtonPress = false;
                
                if(menuAction=='save'){
                    this.fn_checkValidations();
                }
                else if(menuAction=='new'){
                    this.$router.push({path:'/masters/accounts/groups/new', query:{tagId:this.guidWeb(), ls:1}})
                }
                else if(menuAction=='reset'){
                    this.fn_resetForm();
                }
            },

            // fn_showWebView: function () {
            //     var viewObject = {};
            //     viewObject.ToolbarTitle = "Account Groups";
            //     viewObject.TopMenu = [menuItem.save];
            //     viewObject.isBottomMenu = true;

            //     var tagId = this.formId;
            //     var self = this;
            //     this.showWebView(tagId, viewObject, 
            //         {
            //             onSuccess: function(response){
            //               console.log(response);
            //             }, 
            //             onError: function(error){
            //               console.log(error);
            //             }, 
            //             // onChange: null,
            //             onMenuItemClick: function (tagId, menuId, menuAction) {
            //                 self.fn_menuItemClick(tagId, menuId, menuAction)
            //             }
            //         }
            //     );
            // },

            fn_goBack: function(){
                this.$refs['ref_dialogDiscard'].closeDialogWeb();
                this.$root.viaKeyboardShortCut = false;
                this.$refs['ref_dialogForm'].closeDialogWeb();
                localStorage.removeItem(this.draftStorageId);
                this.backButtonPress = true;
                setTimeout(() => {
                    if(this.nextRoute.path){
                        this.nextRoute.query ? this.$router.replace({path:this.nextRoute.path, query:this.nextRoute.query}) : this.$router.replace({path:this.nextRoute.path});
                    }
                    else{
                        this.$router.go(-1);
                    }
                }, 50);
            }

        },
        mounted: function(){

            this.$eventHub.$on('save', () => {
                this.$refs['ref_dialogForm'].fn_validateForm();
            });

            this.$eventHub.$on('escape', () => {
                this.fn_closeDialogForm();
            });

            setTimeout(() => {
                this.Form.isNew ? this.$root.fn_copyFormObject(this.Form, this.formId) : '';
            }, 100);

        },
        beforeRouteEnter (to, from, next) {
            next(vm => {

                let itemId = null;
                let copyData = false;

                // to.query && to.query.copy && from.name == 'itemlist' ? copyData = true : '';
                to.query && to.query.copy ? copyData = true : '';

                // if(to.query && to.query.itemId && from.name == 'itemlist'){
                //     itemId = to.query.itemId;
                // }
                if(to.query && to.query.itemId){
                    itemId = to.query.itemId;
                }

                if(to.params && to.params.tagId){//from display view
                    itemId = to.params.tagId;
                }

                if(to.query && to.query.tagId){//in case of new form
                    vm.formId = to.query.tagId;
                    vm.draftStorageId = 'draft_master_'+vm.formId;
                }
                else if(to.params && to.params.tagId){//in case of edit form
                    vm.formId = to.params.tagId;
                    vm.draftStorageId = 'draft_master_'+vm.formId;
                }

                if(localStorage.getItem(vm.draftStorageId)){
                    let dataObj = JSON.parse(localStorage.getItem(vm.draftStorageId));
                    vm.Form = JSON.parse(dataObj.formData);
                }

                // vm.fn_accountGroups();

                vm.$refs['ref_dialogForm'].openDialogWeb();

                if(itemId){
                    !localStorage.getItem(vm.draftStorageId) ? vm.fn_get(itemId, copyData, true) : '';
                }

                let isCalled = false;
                vm.$eventHub.$on('connected', () => {
                    setTimeout(() => {
                        if(!isCalled){
                            isCalled = true;
                            vm.disableOnSave = false;
                            vm.saveBtnKey++;
                            // !vm.accountGroups.length ? vm.fn_accountGroups() : '';
                            itemId ? vm.fn_get(itemId, copyData, true) : '';
                        }

                        setTimeout(() => {
                            isCalled = false;
                        }, 3000);
                    }, 1000);
                });

            })
        },
        beforeRouteUpdate (to, from, next) {

            if(to.query && to.query.tagId){//in case of new form
                this.formId = to.query.tagId;
                this.draftStorageId = 'draft_master_'+this.formId;
            }
            else if(to.params && to.params.tagId){//in case of edit form
                this.formId = to.params.tagId;
                this.draftStorageId = 'draft_master_'+this.formId;
            }

            if(localStorage.getItem(this.draftStorageId)){
                let dataObj = JSON.parse(localStorage.getItem(this.draftStorageId));
                this.Form = JSON.parse(dataObj.formData);
            }
            else{
                this.fn_clearForm();
            }

            this.$refs['ref_dialogForm'].openDialogWeb();

            let isCalled = false;
            this.$eventHub.$once('connected', () => {
                setTimeout(() => {
                    if(!isCalled){
                        isCalled = true;
                        this.disableOnSave = false;
                        this.saveBtnKey++;
                    }
                }, 1000);
            });
            
            next();
        },
        beforeRouteLeave (to, from, next) {
            if(this.$root.viaKeyboardShortCut){
                this.nextRoute.path = to.path;
                this.nextRoute.query = to.query;
                this.fn_closeDialogForm();
            }
            else{
                this.nextRoute.path = null;
                this.nextRoute.query = null;
                this.$eventHub.$off('save');
                this.$eventHub.$off('escape');
                this.$eventHub.$off('connected');
                next();
            }
        },
    }

</script>